<template>
    <div class="the-sidebar">
        <v-list nav>
            <v-list-item v-for="item in items" :key="item.title" :to="{name: item.name}" exact color="primary">
                <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
    export default {
        name: "TheSidebar",
        data() {
            return {
                items: [
                    {title: 'Клиенты', icon: 'mdi-account-multiple', name: 'clients.list'},
                    {title: 'Сообщения', icon: 'mdi-email-multiple', name: 'messages.list'},
                    {title: 'Абонементы', icon: 'mdi-credit-card-multiple', name: 'cards.list'},
                    {title: 'Статистика', icon: 'mdi-chart-bar', name: 'stats'},
                    {title: 'Виды абонементов', icon: 'mdi-ticket', name: 'card-types.list'},
                    {title: 'Настройки', icon: 'mdi-settings', name: 'settings'},
                ]
            }
        }
    }
</script>

<style lang="scss">
    .the-sidebar {

        .v-list {

        }

        .v-list-item {

            .v-list-item__icon {

                &:first-child {
                    margin: auto 16px auto 8px;
                }
            }
        }
    }
</style>
